import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCommentAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={24}
    height={24}
    fill='none'
    {...props}
  >
    <circle cx={12} cy={12} r={11.5} fill='url(#CommentAvatar_svg__a)' stroke='#E0E3EB' />
    <defs>
      <pattern
        id='CommentAvatar_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#CommentAvatar_svg__b' transform='scale(.00253)' />
      </pattern>
      <image
        xlinkHref='/images/icons/comment-avatar-5d63cd4d.webp'
        id='CommentAvatar_svg__b'
        width={396}
        height={396}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgCommentAvatar;
